import _ from 'lodash';
import { useMemo } from 'react';
import { twoWayDiff } from 'src/components/formEditor/modals/tagsModal/useGetFieldChanges';
import { DataType, SkippedFieldsDataType } from 'src/components/formEditor/uiEditor/uiEditor';
import { useContextSelector } from 'use-context-selector';
import { FormHistoryContext } from '../provider/historyTab.context';

export const useGetFieldChanges = () => {
  const { selectedVersion, previousVersionOfSelectedVersion } = useContextSelector(FormHistoryContext, (x) => x);

  const valueChanges: DataType = useMemo(
    () => twoWayDiff(selectedVersion?.value ?? {}, previousVersionOfSelectedVersion?.value ?? {}),
    [selectedVersion?.value, previousVersionOfSelectedVersion?.value],
  );
  const skipFieldChanges: SkippedFieldsDataType = useMemo(
    () => twoWayDiff(selectedVersion?.fieldSkipReasons ?? {}, previousVersionOfSelectedVersion?.fieldSkipReasons ?? {}),
    [selectedVersion?.fieldSkipReasons, previousVersionOfSelectedVersion?.fieldSkipReasons],
  );

  const anyChanges = useMemo(
    () => !_.isEmpty(valueChanges) || !_.isEmpty(skipFieldChanges),
    [skipFieldChanges, valueChanges],
  );

  const anyEditedFields =
    Object.keys(valueChanges).some((key) => _.has(previousVersionOfSelectedVersion?.value, key)) ||
    Object.keys(skipFieldChanges).some((key) => _.has(previousVersionOfSelectedVersion?.fieldSkipReasons, key));

  return { valueChanges, skipFieldChanges, anyChanges, anyEditedFields };
};
